<mat-form-field
	class="search-field"
	[ngClass]="{ 'search-field--outline': appearance === 'outline' }"
	[appearance]="appearance"
>
	<mat-label *ngIf="label">{{ label }}</mat-label>
	<mat-icon *ngIf="prefixIcon" matPrefix class="mat-icon search-field__icon">{{ prefixIcon }}</mat-icon>
	<ng-container *ngIf="matAutocomplete; else withoutAutocomplete">
		<input
			matInput
			[formControl]="control"
			(keydown.enter)="onEnter()"
			[disabled]="disabled"
			[placeholder]="placeholder"
			[attr.spellcheck]="spellcheck === null ? null : spellcheck"
			[matAutocomplete]="matAutocomplete"
		/>
	</ng-container>
	<ng-template #withoutAutocomplete>
		<input
			matInput
			[formControl]="control"
			(keydown.enter)="onEnter()"
			[disabled]="disabled"
			[attr.placeholder]="placeholder || null"
			[attr.spellcheck]="spellcheck === null ? null : spellcheck"
		/>
	</ng-template>
	<ng-container matSuffix *ngIf="hasSuffixActions || suffixIcon">
		<div class="search-field__actions" *ngIf="hasSuffixActions">
			<button
				*ngIf="showClear && control.value"
				mat-icon-button
				(click)="onClear()"
				class="clear-btn search-field__icon"
				[disabled]="disabled"
			>
				<mat-icon class="mat-icon">close</mat-icon>
			</button>
			<button *ngIf="showButton" mat-icon-button (click)="onEnter()" [disabled]="disabled" class="search-field__icon search-btn border-0">
				<mat-icon class="mat-icon">search</mat-icon>
			</button>
		</div>
		<mat-icon *ngIf="suffixIcon" class="mat-icon search-field__icon">{{ suffixIcon }}</mat-icon>
	</ng-container>
</mat-form-field>
